module.exports = __webpack_public_path__ + "ionicons.05acfdb568b3df49ad31.woff";


//////////////////
// WEBPACK FOOTER
// E:/Release/InzuzoA/InzuzoA/fonts/ionicons.woff?v=2.0.0
// module id = ../../../../../fonts/ionicons.woff?v=2.0.0
// module chunks = styles